import styled from "@emotion/styled";
import "@mondaydotcomorg/monday-ui-components/dist/CardList.css";
import { TABLET_QUERY_MIN_WIDTH } from "/constants/vp-sizes";
export const StyledTemplateList = styled.div`
  @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
    .template-list-items {
      .card-list--component {
        margin: 0;

        .title-wrapper {
          text-align: center;
        }

        .card-list-wrapper {
          justify-content: center;

          .card-item-component-wrapper {
            margin: 0 8px 32px 8px;
          }
        }
      }
    }
  }
`;
